import * as React from "react"
import { cn } from "../../lib/utils"

interface ToggleSwitchProps {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  leftLabel: string
  rightLabel: string
  leftIcon?: React.ReactNode
  rightIcon?: React.ReactNode
  className?: string
}

export const ToggleSwitch = React.forwardRef<
  HTMLInputElement,
  ToggleSwitchProps
>(({ 
  checked, 
  onCheckedChange, 
  leftLabel, 
  rightLabel, 
  leftIcon, 
  rightIcon, 
  className,
  ...props 
}, ref) => {
  // Code icon component
  const CodeIcon = () => (
    <svg className="toggle-icon" fill="currentColor" viewBox="0 0 24 24">
      <path d="M8.7 15.9L4.8 12l3.9-3.9c.39-.39.39-1.01 0-1.4s-1.01-.39-1.4 0l-4.59 4.59c-.39.39-.39 1.02 0 1.41L7.3 17.3c.39.39 1.01.39 1.4 0s.39-1.01 0-1.4zm6.6 0l3.9-3.9-3.9-3.9c-.39-.39-.39-1.01 0-1.4s1.01-.39 1.4 0l4.59 4.59c.39.39.39 1.02 0 1.41L16.7 17.3c-.39.39-1.01.39-1.4 0s-.39-1.01 0-1.4z"/>
    </svg>
  )

  // Slides/Presentation icon component  
  const SlidesIcon = () => (
    <svg className="toggle-icon" fill="currentColor" viewBox="0 0 24 24">
      <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
    </svg>
  )

  return (
    <div className={cn("flex items-center justify-center", className)}>
      {/* Elegant Toggle Switch Only */}
      <div className={cn("toggle-container", checked && "checked")}>
        <input
          ref={ref}
          type="checkbox"
          className="toggle-checkbox"
          checked={checked}
          onChange={(e) => onCheckedChange(e.target.checked)}
          {...props}
        />
        <div className="toggle-knob">
          {!checked ? <CodeIcon /> : <SlidesIcon />}
        </div>
      </div>
    </div>
  )
})

ToggleSwitch.displayName = "ToggleSwitch"